import { LOCALES } from "../locales";

export default {
  [LOCALES.UZBEK]: {
    // ==================== BUTTONS ====================
    "button.login": "Kirish",
    "button.submit": "Jo'natish",
    "button.cancel": "Orqaga",
    "button.delete": "O'chirish",
    "button.edit": "O'zgartirish",
    "button.print": "Chop etish",
    "button.sell": "Sotish",
    "button.clear": "Tozalash",
    "button.add_payment": "To'lov qo'shish",
    "button.save": "Saqlash",
    "button.generate_contract": "Shartnoma yaratish",
    "button.contract": "Shartnoma",
    "button.sign": "Imzolash",
    "button.manager_signed": "Manager imzoladi",
    "button.verify_user": "User ni tasdiqlash",
    "button.send_sms": "SMS yuborish",
    "button.download": "Yuklab olish",

    // ==================== FORM LABELS ====================
    "form.label.username": "Foydalanuvchi:",
    "form.label.password": "Parol:",
    "form.label.customer_name": "Mijoz to'liq ismi",
    "form.label.customer_phone": "Mijoz raqami",
    "form.label.customer_phone2": "Qo'shimcha telefon",
    "form.label.email": "Email",
    "form.label.sale_status": "Sotuv holati",
    "form.label.price_per_sqm": "1 m² uchun narx o'zgartirish ($)",
    "form.label.initial_payment": "Boshlang'ich to'lov (%)",
    "form.label.payment_duration": "To'lov davomiyligi (oy)",
    "form.label.installment": "Muddatli to'lov",
    "form.label.booked": "Bron qilish",
    "form.label.additional_info": "Qo'shimcha ma'lumotlar",
    "form.label.signatory": "Imzo chekuvchi",
    "form.error.signatory_required": "Imzo chekuvchini tanlang",
    "form.label.payment_amount": "To'langan summa:",
    "form.label.payment_type": "To'lov turi",
    "form.label.address": "Manzil",
    "form.label.passport_given_place": "Pasport berilgan joy",
    "form.label.passport_given_date": "Pasport berilgan sana",
    "form.label.series": "Pasport seriyasi",
    "form.label.pnfl": "JSHSHIR",
    "form.label.birth_date": "Tug'ilgan sana",
    "form.label.booking_payment": "Bron to'lovi",
    "form.label.payment_method": "To'lov turi",
    "form.label.upload_file": "Fayl yuklash",
    "form.label.file_comment": "Fayl izohi",
    "form.label.attached_file": "Biriktirilgan fayl",
    "form.label.repair": "Ta'mir",
    "form.label.repair_with": "Ta'mir bilan",
    "form.label.repair_without": "Ta'mirsiz",

    // ==================== FORM VALIDATION ====================
    "form.error.username_required": "Foydalanuvchi ismini kiritish majburiy!",
    "form.error.password_required": "Parolni kiritish majburiy!",
    "form.error.customer_name_required": "Mijozni ismini kiritish majburiy!",
    "form.error.customer_phone_required": "Mijoz raqamini kiritish majburiy",
    "form.error.customer_phone2_required": "Qo'shimcha telefon raqamini kiritish majburiy",
    "form.error.email_required": "Email kiritish majburiy",
    "form.error.email_invalid": "Email formati noto'g'ri",
    "form.error.phone_incomplete": "Iltimis raqamni to'liq kiriting!",
    "form.error.price_required": "Maydon narxni kiritish majburiy!",
    "form.error.initial_payment_required": "Boshlang'ich to'lovni kiritish majburiy!",
    "form.error.duration_required": "To'lov davomiyligini kiritish majburiy!",
    "form.error.amount_required": "To'langan summani kiritish majburiy!",
    "form.error.address_required": "Manzilni kiritish majburiy!",
    "form.error.passport_given_place_required": "Pasport berilgan joyni kiritish majburiy!",
    "form.error.passport_given_date_required": "Pasport berilgan sanani kiritish majburiy!",
    "form.error.series_required": "Pasport seriyasini kiritish majburiy!",
    "form.error.pnfl_required": "JShShIRni kiritish majburiy!",
    "form.error.birth_date_required": "Tug'ilgan sanani kiritish majburiy!",
    "form.error.birth_date_min_age": "Mijoz 18 yoshdan katta bo'lishi kerak!",
    "form.error.phone_length": "Telefon raqami qisqa!",
    "form.error.password_min": "Parol kamida 8 ta belgi bo'lishi kerak!",
    "form.error.full_name_required": "To'liq ismni kiritishingiz majburiy!",
    "form.error.role_required": "Rolni kiritishingiz majburiy!",
    "form.error.phone_required": "Telefonni kiritishingiz majburiy!",
    "form.error.name_required": "Nomini kiritishingiz majburiy!",
    "form.label.initial_payment_discount":"Chegirma foiz",
    "form.error.initial_payment_discount_required":"Chegirma foiz kerak",
    "form.error.booking_payment_required": "Bron to'lovini kiritish majburiy!",
    "form.error.type_required": "Sotuv holatini tanlash majburiy!",
    "form.label.day_of_payment": "To'lov kuni",
    "form.error.day_of_payment_required": "To'lov kunini kiritish majburiy!",
    "form.label.client_type": "Mijoz turi",
    "form.label.individual": "Jismoniy shaxs",
    "form.label.legal": "Yuridik shaxs",
    "form.label.manual": "Qo'lda",
    "form.label.via_myid": "MYID orqali",
    "form.label.director": "Direktor",
    "form.label.bank": "Bank",
    "form.label.bank_account": "Hisob raqami",
    "form.label.mfo_code": "MFO kodi",
    "form.label.oked_code": "OKED kodi",
    "form.label.inn": "INN",
    "form.error.director_required": "Direktor ismini kiritish majburiy!",
    "form.error.bank_required": "Bank nomini kiritish majburiy!",
    "form.error.bank_account_required": "Hisob raqamini kiritish majburiy!",
    "form.error.mfo_code_required": "MFO kodini kiritish majburiy!",
    "form.error.oked_code_required": "OKED kodini kiritish majburiy!",
    "form.error.inn_required": "INNni kiritish majburiy!",
    // ==================== STATUS VALUES ====================
    "status.sold": "Sotildi",
    "status.booked": "Bron qilindi",
    "status.not_paid": "To'liq to'lanmadi",
    "status.empty": "Bo'sh",
    "status.not_for_sale": "Sotilmaydi",
    "status.active": "Aktiv",
    "status.blocked": "Bloklangan",
    "status.reserved_paid": "To'langan bron",

    // ==================== TABLE COLUMNS ====================
    "table.column.no": "NO",
    "table.column.username": "Foydalanuvchi nomi",
    "table.column.role": "Rol",
    "table.column.phone": "Telefon",
    "table.column.status": "Holati",
    "table.column.action_type": "Amal turi",
    "table.column.target": "Target",
    "table.column.timestamp": "Bajarilgan vaqti",
    "table.column.actions": "Harakatlar",
    "table.column.amount": "Summa",
    "table.column.payment_time": "To'lov vaqti",
    "table.column.delete": "O'chirish",
    "table.column.total_area": "Jami maydon",
    "table.column.total_paymentm2": "Umumiy maydon narx",
    "table.column.total_paymentRepair": "Umumiy ta'mir narx",
    "table.column.total_payment_discount": "Chegirma narx",

    "table.column.total_payment": "Jami to'lov",
    "table.column.initial_payment": "Boshlang'ich to'lov",
    "table.column.monthly_payment": "Oylik to'lov",

    // ==================== APARTMENT INFO ====================
    "apartment.info": "Xonadon ma'lumotlari",
    "apartment.size": "O'lcham:",
    "apartment.rooms": "Xonalar soni:",
    "apartment.floor": "Qavat:",
    "apartment.status": "Kelishuv holati:",
    "apartment.price": "Narxi:",
    "apartment.lodjiya": "Lodjiya:",
    "apartment.block": "Blok:",
    "apartment.building": "Bino",
    "apartment.area": "Maydon:",
    "apartment.apartment_number": "№ Хона raqami:",

    // ==================== PARKING INFO ====================
    "menu.apartments": "Kvartiralar",
    "menu.office": "Ofis",
    "menu.parking": "Parking",
    "menu.storage_room": "Omborxona",

    // ==================== STORAGE ROOM INFO ====================
    "storage_room.number": "Omborxona raqami:",

    // ==================== SALE INFO ====================
    "sale.info": "Sotuv ma'lumotlari",
    "sale.customer_name": "FIO:",
    "sale.customer_phone": "Mijoz raqami:",
    "sale.sold_price_sqm": "Sotilgan narxi (m²):",
    "sale.user":"Sotuvchi:",
    "sale.initial_payment": "Boshlang'ich to'lov:",
    "sale.monthly_payment": "Oylik to'lov ({months}oy):",
    "sale.additional_info": "Qo'shimcha ma'lumotlar:",
    "sale.delete_order": "Buyurtmani o'chirish",
    "sale.reserved.day":"Bron vaqti (kunda)",

    // ==================== PAYMENT INFO ====================
    "payment.info": "To'lov ma'lumotlari",
    "payment.add": "To'lov qo'shish",
    "payment.cash": "100% to'lov",
    "payment.card": "Karta",
    "payment.delete_confirm": "Rostanam to'lovni o'chirmoqchimisiz?",
    "payment.delete_warning": "To'lovni o'chirganingizdan so'ng uni qayta tiklay olmaysiz!",
    "payment.delete_success": "To'lov o'chirildi",
    "payment.delete_error": "To'lov o'chirilmadi",
    "payment.upload_check": "Chek yuklash",
    "payment.installment": "Bo'lib to'lash",
    "payment.booking": "Bron qilish",
    "payment.click": "Click",
    "payment.payme": "Payme",
    "payment.check": "Chek",
    "payment.amount_placeholder": "Summa (UZS):",

    // ==================== ORDER INFO ====================
    "order.delete_confirm": "Rostanam buyurtmani o'chirmoqchimisiz?",
    "order.delete_warning": "Buyurtmani o'chirganingizdan so'ng uni qayta tiklay olmaysiz va barcha to'lovlar ham o'chib ketadi!",
    "order.delete_success": "Buyurtma o'chirildi",
    "order.delete_error": "Buyurtma o'chirilmadi",

    // ==================== FILTERS ====================
    "filter.title": "Filterlar",
    "filter.floors": "Qavatlar:",
    "filter.buildings": "Binolar:",
    "filter.all_buildings": "Barcha binolar",
    "filter.building": "Bino",
    "filter.area": "Xonadon maydoni:",
    "filter.room_count": "Xonadon turlari:",
    "filter.sale_room_count": "Sotilgan xonadon turlari:",
    "filter.clear": "Tozalash",
    "filter.floor_suffix": "qavat",
    "filter.room_suffix": "xona",
    "filter.sync":"Sinxronlash",
    "filter.exclude_smoke":"Chekish mumkin bo'lgan uylar",
    "filter.status": "Holat:",
    "filter.all_status": "Barcha holatlar",
    "filter.all": "Hammasi",
    "filter.sale_room_suffix": "Sotilgan xona",
    "filter.show_favorites": "Faqat sevimlilar",



    // ==================== MENU/SIDEBAR ====================
    "menu.erp": "ERP",
    "menu.admin": "Admin",
    "menu.chess": "Shaxmatka",
    "menu.catalogs": "Kataloglar",
    "menu.blocks": "Bloklar",
    "menu.floors": "Qavatlar",
    "menu.schema": "Sxema",
    "menu.users": "Foydalanuvchilar",
    "menu.log": "Amallar",

    // ==================== USER MENU ====================
    "user.profile": "Mening profilim",
    "user.logout": "Chiqish",

    // ==================== MESSAGES ====================
    "message.success.updated": "Muvoffaqiyatli o'zgartirildi",
    "message.success.created": "Muvoffaqiyatli yaratildi",
    "message.success.deleted": "Muvoffaqiyatli o'chirildi!",
    "message.error.occurred": "Xatolik yuz berdi",
    "message.error.delete": "O'chirishda xatolik yuz berdi!",
    "message.loading": "Yuklanmoqda...",
    "message.confirm.delete": "Rostdanam o'chirib tashlamoqchimisiz!",

    // ==================== CRM ====================
    "crm.all": "Barchasi",
    "crm.new": "Yangi",
    "crm.in_progress": "Jarayonda",
    "crm.completed": "Bajarilgan",
    "crm.canceled": "Bekor qilingan",
    "crm.archived": "Arxivlangan",
    "crm.deleted": "O'chirilgan",
    "crm.spam": "Spam",
    "crm.trash": "Axlat",
    "crm.leads": "lidlar:",

    // ==================== PRINT ====================
    "print.title": "Chop etish ma'lumotlari",
    "print.document_title": "MAYDONLI XONADON",
    "print.address": "Manzil:",
    "print.sales_address": "Sotuv bo'lim manzili:",
    "print.sales_phone": "Sotuv bo'lim raqami:",
    "print.remaining_amount": "Qolgan summa:",
    "print.price_per_sqm": "1m² maydon narxi:",

    // ==================== MISC ====================
    "misc.remember_me": "Eslab qolish",
    "misc.search": "Qidirish",
    "misc.month": "oy",
    "misc.currency": "UZS",
    "misc.sqm": "m²",
    "misc.percent": "%",
    "misc.room": "Xona",
    "misc.blocks": "Bloklar",

    // ==================== ROLES ====================
    "role.seller": "Sotuvchi",
    "role.admin": "Admin",
    "role.finance": "Finance",
    "role.superadmin": "Superadmin",
    "role.director": "Direktor",

    // ==================== PAGES ====================
    "page.users": "Foydalanuvchilar sahifasi",
    "page.actions": "Amallar sahifasi",
    "page.catalogs": "Kataloglar",

    // ==================== LANGUAGE ====================
    "language.uzbek": "O'zbek",
    "language.russian": "Русский",

    // ==================== COMMON (legacy support) ====================
    "common.page.user": "Foydalanuvchilar sahifasi",
    "common.page.action": "Amallar sahifasi",
    "common.username": "Foydalanuvchi nomi",
    "common.status": "Holat",
    "common.full_name": "To'liq Ism",
    "common.name": "Nomi",
    "common.role": "Rol",
    "common.phone": "Telefon",
    "common.search": "Qidirish",
    "common.password": "Parol",
    "common.delete": "O'chirish",
    "common.yes": "Ha",
    "common.no": "Yo'q",
    "common.foods": "Ovqatlar",
    "common.services": "Xizmatlar",
    "common.start_time": "Boshlanish vaqti",
    "common.end_time": "Tugash vaqti",
    "common.customer_name": "Mijoz ismi",
    "common.total_people": "Odamlar soni",
    "common.currency": "Pul birligi",
    "common.description": "Batafsil ma'lumot",
    "common.customer_phone": "Mijoz raqami",
    "common.total_budget": "Jami narxi",
    "common.individual_package": "Kishi boshiga narxi",
    "common.sidebar.chess": "Shaxmatka",
    "common.sidebar.dashboard": "Dashboard",

    "common.sidebar.catalogs": "Kataloglar",
    "common.sidebar.blocks": "Bloklar",
    "common.sidebar.floors": "Qavatlar",
    "common.sidebar.schema": "Sxema",
    "common.sidebar.users": "Foydalanuvchilar",
    "common.sidebar.log": "Amallar",
    "common.sidebar.dollar_rate": "Dollar kursi",
    "common.sidebar.orders": "Buyurtmalar",
    "common.sidebar.delete_orders": "O'chirilgan buyurtmalar",
    "order.deleted.page.title": "O'chirilgan buyurtmalar",
    "order.type.sold": "Sotilgan",
    "order.type.not_full_paid": "Rassrochka",
    "order.type.reserved_paid": "Pullik bron",
    "order.type.mortgage": "Ipoteka",
    "order.type.reserved": "Bron",
    "order.page.title": "Buyurtmalar",
    "order.field.id": "ID",
    "order.field.client": "Mijoz",
    "order.field.phone": "Telefon",
    "order.field.object": "Obyekt",
    "order.field.contractNumber": "Shartnoma raqami",
    "order.field.signature": "Imzo",
    "order.field.price": "Narxi",
    "order.field.priceCurrency": "Valyuta",
    "order.field.price_m2": "1 m² narxi",
    "order.field.discount": "Chegirma",
    "order.field.type": "Turi",
    "order.field.paymentDurationPerMonth": "To'lov muddati (oy)",
    "order.field.downPaymentPercent": "Boshlang'ich to'lov (%)",
    "order.field.downPaymentSum": "Boshlang'ich to'lov summasi",
    "order.field.description": "Izoh",
    "order.field.bank": "Bank",
    "order.field.file": "Fayl",
    "order.field.fileComment": "Fayl izohi",
    "order.field.user": "Menejer",
    "order.field.apartment": "Kvartira",
    "order.field.parking": "Parking",
    "order.field.storage": "Omborxona",
    "order.field.contractType": "Shartnoma turi",
    "order.field.contractType.online": "Online",
    "order.field.contractType.offline": "Offline",
    "order.field.contract": "Shartnoma",
    "order.field.createdAt": "Yaratilgan sana",
    "order.field.updatedAt": "Yangilangan sana",
    "order.object.apartment": "Kvartira",
    "order.object.parking": "Parking",
    "order.object.storage": "Omborxona",
    "order.signature.signed": "Imzolangan",
    "order.signature.unsigned": "Imzolanmagan",
    "order.empty": "-",
    "navbar.current_dollar_rate": "Joriy dollar kursi:",
    "apartment.pcs":"ta",


    // ==================== INPUT ERRORS (legacy support) ====================
    "input.error.phone-length": "Telefon raqami qisqa!",
    "input.error.password<8": "Parol kamida 8 ta belgi bo'lishi kerak!",
    "input.required.password": "Parolni kiritishingiz majburiy!",
    "input.required.full_name": "To'liq ismni kiritishingiz majburiy!",
    "input.required.role": "Rolni kiritishingiz majburiy!",
    "input.required.phone": "Telefonni kiritishingiz majburiy!",
    "input.required.name": "Nomini kiritishingiz majburiy!",
    "input.required.foods": "Ovqatlarni kiritishingiz majburiy!",
    "input.required.start_time": "Boshlanish vaqtini kiritishingiz majburiy!",
    "input.required.end_time": "Tugash vaqtni kiritishingiz majburiy!",
    "input.required.customer_name": "Mijoz ismini kiritishingiz majburiy!",
    "input.required.total_people": "Odamlar sonini kiritishingiz majburiy!",
    "input.required.username": "Foydalanuvchi nomini kiritishingiz majburiy!",

    // ==================== NOTIFICATIONS (legacy support) ====================
    "notification.success.delete": "Muvoffaqiyatli o'chirildi!",
    "notification.error.delete": "O'chirishda xatolik yuz berdi!",
    "confirm.delete": "Rostdanam o'chirib tashlamoqchimisiz!",

    "chess.big": "Katta shaxmatka",
    "chess.small": "Kichik shaxmatka",
    "floor.high":"Yuqori qavat",
    "floor.basement":"Podval qavat",

    // ==================== DOLLAR RATE ====================
    "dollar_rate.rate": "Kurs",
    "dollar_rate.add": "Kurs qo'shish",
    "dollar_rate.edit": "Kursni tahrirlash",
    "dollar_rate.rate_placeholder": "Kursni kiriting",
    "form.error.rate_required": "Kursni kiritish majburiy!",
    "button.add": "Qo'shish",

    // ==================== DASHBOARD ====================
    "dashboard.price.type":"so'm",
    "dashboard.title": "Dashboard",
    "dashboard.total_area": "Jami maydon",
    "dashboard.total_amount": "Jami summa",
    "dashboard.sold_area": "Sotilgan maydon",
    "dashboard.unsold_area": "Sotilmagan maydon",
    "dashboard.sold_average": "Sotilgan uylarni o'ratcha narx",
    "dashboard.unsold_average": "Sotilmagan uylarni o'ratcha narx",
    "dashboard.by_area": "Maydon bo'yicha (m²)",
    "dashboard.by_amount": "Summa bo'yicha (so'm)",
    "dashboard.room_statistics": "Xonalar statistikasi",
    "dashboard.room_statistics_title": "Xonalar bo'yicha statistika",
    "dashboard.sold": "Sotilgan",
    "dashboard.unsold": "Sotilmagan",
    "dashboard.sold_m2": "Sotilgan (m²)",
    "dashboard.unsold_m2": "Sotilmagan (m²)",
    "dashboard.sold_sum": "Sotilgan (so'm)",
    "dashboard.unsold_sum": "Sotilmagan (so'm)",
    "dashboard.room_suffix": "xonali",

    "parking.number":"Turargoh raqami",
    "parking.info":"Turargoh ma'lumotlari",

  //   storage rooms
    "storage.number":"Omborxonalar raqami",
    "storage.info":"Omborxona malumotlari",

  //   order log
    "orderlog.title": "Audit tarixi",
    "orderlog.action": "Harakat",
    "orderlog.details": "Tafsilotlar",
    "orderlog.time": "Vaqt",
    "orderlog.button": "Audit",
    "orderlog.order_created": "Buyurtma yaratildi",
    "orderlog.order_edited": "Buyurtma o'zgartirildi",
    "orderlog.order_deleted": "Buyurtma o'chirildi",
    "orderlog.type_changed": "Turi o'zgartirildi",
    "orderlog.payment_created": "To'lov yaratildi",
    "orderlog.payment_deleted": "To'lov o'chirildi",
    "orderlog.user": "Foydalanuvchi",

    // ==================== SIGNATORY ====================
    "common.sidebar.signatory": "Imzo chekuvchilar",
    "signatory.page.title": "Imzo chekuvchilar",
    "signatory.add": "Imzo chekuvchi qo'shish",
    "signatory.edit": "Imzo chekuvchini tahrirlash",
    "signatory.field.user": "Foydalanuvchi",
    "signatory.field.fullName": "To'liq F.I.O",
    "signatory.field.position": "Lavozimi",
    "signatory.field.proxyId": "Ishonchnoma raqami",
    "signatory.field.pinfl": "PINFL",
    "signatory.field.birthDate": "Tug'ilgan sana",
    "signatory.field.proxyDate": "Ishonchnoma sanasi",
    "signatory.field.authorityBasis": "Vakolat asosi",
    "signatory.authorityBasis.power_of_attorney": "Ishonchnoma",
    "signatory.authorityBasis.charter": "Ustav",
    "signatory.error.fullName_required": "F.I.O kiritish majburiy!",
    "signatory.error.position_required": "Lavozimni kiritish majburiy!",

    // ==================== OFFLINE CONTRACT ====================
    "button.offline_contract": "Offline shartnoma yuklash",
    "offline_contract.title": "Offline shartnoma yuklash",
    "offline_contract.upload_text": "Faylni tanlang yoki shu yerga tashlang",
    "offline_contract.success": "Shartnoma muvaffaqiyatli yuklandi",

  },
};
